export type DailyBriefHeadlineInput = {
  criticalAttention:
    number;

  importantAttention:
    number;

  eventsToday:
    number;

  deadlinesToday:
    number;

  tasksToday:
    number;

  followupsDue:
    number;

  installmentsDue:
    number;
};

const plural = (
  count:
    number,

  singular:
    string,

  pluralForm:
    string
) =>
  `${count} ${
    count ===
      1
      ? singular
      : pluralForm
  }`;

export const buildDailyBriefHeadline = (
  input:
    DailyBriefHeadlineInput
) => {
  if (
    input
      .criticalAttention >
    0
  ) {
    return `${plural(
      input.criticalAttention,
      'item crítico exige',
      'itens críticos exigem'
    )} atuação prioritária hoje.`;
  }

  if (
    input.deadlinesToday >
    0
  ) {
    return `${plural(
      input.deadlinesToday,
      'prazo jurídico vence',
      'prazos jurídicos vencem'
    )} hoje.`;
  }

  if (
    input
      .importantAttention >
    0
  ) {
    return `${plural(
      input.importantAttention,
      'pendência importante merece',
      'pendências importantes merecem'
    )} revisão.`;
  }

  if (
    input.eventsToday >
    0
  ) {
    return `${plural(
      input.eventsToday,
      'compromisso está',
      'compromissos estão'
    )} previsto(s) para hoje.`;
  }

  if (
    input.tasksToday >
      0 ||
    input.followupsDue >
      0 ||
    input.installmentsDue >
      0
  ) {
    return 'Há atividades operacionais para concluir hoje.';
  }

  return 'Nenhuma pendência prioritária foi identificada para hoje.';
};

export const buildDailyBriefTone = (
  criticalAttention:
    number,

  importantAttention:
    number
) => {
  if (
    criticalAttention >
    0
  ) {
    return 'critical' as const;
  }

  if (
    importantAttention >
    0
  ) {
    return 'important' as const;
  }

  return 'normal' as const;
};